import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, ButtonGroup, Card, Table } from "@themesberg/react-bootstrap";
import { DevicesModelDialog } from "../../../loans/components/DevicesModelDialog";
import { SchedulesModelDialog } from "../../../loans/components/SchedulesModelDialog";


class InsuranceLoans extends Component {
    state = {
        loading: false,
        showDevices: false,
        showSchedules: false,
        getDevices: [],
        getSchedules: [],
    }
    //
    componentDidMount = async () => {
        this.setState({ loading: true });

        this.setState({ loading: false });
    }
    //
    showDevices = () => {
        this.setState({ showDevices: true, });
    }
    //
    showSchedule = () => {
        this.setState({ showSchedules: true });
    }
    //
    hideSchedule = () => {
        this.setState({ showSchedules: false, getSchedules: [], });
    }
    //
    hideDevices = () => {
        this.setState({ showDevices: false, getDevices: [], });
    }
    //
    setDevices = (devices) => {
        this.setState({
            getDevices: devices,
        });
    }
    //
    setPaymentSchedules = (schedules) => {
        this.setState({
            getSchedules: schedules,
        });
    }

    //
    render() {
        const { showDevices, getDevices, showSchedules, getSchedules } = this.state;
        //
        return (
            <>
                <Card>
                    <Card.Body className={'overflow-auto'}>
                        <div className="btn-toolbar" style={{ marginBottom: 10 }}>
                            <ButtonGroup>
                                <Button variant="outline-primary" size="sm">Export</Button>
                            </ButtonGroup>
                        </div>
                        <Table responsive className="table-centered table-bordered table-nowrap rounded">
                            <thead className="thead-light">
                                <tr>
                                    <th className="border-0">#</th>
                                    <th className="border-0">Name</th>
                                    <th className="border-0">National ID</th>
                                    <th className="border-0">Nationality</th>
                                    <th className="border-0">MSISDN</th>
                                    <th className="border-0">Email address</th>
                                    <th className="border-0">Gender</th>
                                    <th className="border-0">Date of birth</th>
                                    <th className="border-0">Place of birth</th>
                                    <th className="border-0">Device's serial number</th>
                                    <th className="border-0">Modal number</th>
                                    <th className="border-0">Customer onboarded date</th>
                                    <th className="border-0">Device release date</th>
                                    <th className="border-0">Policy</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan={14} className="text-center">No Loans Available !!</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Card.Body>
                    <DevicesModelDialog show={showDevices} close={this.hideDevices} devices={getDevices} />
                    <SchedulesModelDialog show={showSchedules} close={this.hideSchedule} schedules={getSchedules} />
                </Card>
            </>
        );
    }
}

//
const mapStateProps = (state) => {
    const { error, loans } = state.partners;
    return { error, loans, };
}
//
export default connect(mapStateProps, {})(InsuranceLoans);
